import React from 'react';
import UsersTable from '../components/UsersTable';

const Users = () => {
  return <UsersTable />;
};

export default Users;
